export default "__VITE_ASSET__kZif8HJp__"